import { Node } from 'reactflow';
import { reconcileTextModelSelection } from '../components/AiConfigs/constants';

interface DeprecatedCheckResult {
  nodes: Node[];
  deprecatedNodeIds: Set<string>;
}

export function checkDeprecatedModels(
  nodes: Node[],
  technologies: any[],
  companySpaceTechnologies: any[],
  spaceId?: string,
): DeprecatedCheckResult {
  const deprecatedNodeIds = new Set<string>();

  const technologiesToUse =
    spaceId && companySpaceTechnologies.length > 0
      ? companySpaceTechnologies
      : technologies;

  if (!technologiesToUse || technologiesToUse.length === 0) {
    return { nodes, deprecatedNodeIds };
  }

  const updatedNodes = nodes.map(node => {
    if (node.type !== 'commandTextNode') return node;

    const reconciled = reconcileTextModelSelection(
      node.data?.aiSystem,
      node.data?.aiModel,
      technologiesToUse,
    );

    if (!reconciled) return node;

    deprecatedNodeIds.add(node.id);

    return {
      ...node,
      data: {
        ...node.data,
        aiSystem: reconciled.aiSystem,
        aiModel: reconciled.aiModel,
      },
    };
  });

  return { nodes: updatedNodes, deprecatedNodeIds };
}
